export default __webpack_public_path__ + "static/media/cycle.7b7ab4d3.png";